"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPromptFlyoutContent = exports.StyledExpressCartModal = exports.StyledDomainsModal = exports.StyledDomainRecommendation = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _card = _interopRequireDefault(require("@ux/card"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _box = _interopRequireDefault(require("@ux/box"));
const intents = new _intents.default();
const {
  StyledDomainsModal,
  StyledExpressCartModal,
  StyledDomainRecommendation,
  StyledPromptFlyoutContent
} = getStyled();
exports.StyledPromptFlyoutContent = StyledPromptFlyoutContent;
exports.StyledDomainRecommendation = StyledDomainRecommendation;
exports.StyledExpressCartModal = StyledExpressCartModal;
exports.StyledDomainsModal = StyledDomainsModal;
function getStyled() {
  return {
    StyledDomainsModal: /*#__PURE__*/(0, _react.styled)(_modal.default)({
      name: "StyledDomainsModal",
      class: "sc7iztc"
    }),
    StyledExpressCartModal: /*#__PURE__*/(0, _react.styled)(_modal.default)({
      name: "StyledExpressCartModal",
      class: "swqq46e"
    }),
    StyledDomainRecommendation: /*#__PURE__*/(0, _react.styled)(_box.default)({
      name: "StyledDomainRecommendation",
      class: "sn5g89b"
    }),
    StyledPromptFlyoutContent: /*#__PURE__*/(0, _react.styled)(_card.default)({
      name: "StyledPromptFlyoutContent",
      class: "s1ll1y8z"
    })
  };
}